<template>
  <div class="user-center-temp-container">
    <div class="temp-header flex flex-between">
      <div @click="back" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
      <div>导购助手首页模板</div>
      <ul class="flex header-list">
        <li class="btn" @click="save">
          <span class="hmicon icon-baocun"></span>保存
        </li>
      </ul>
    </div>
    <div class="flex">
      <!-- 组件容器 -->
      <div class="component-list">
        <div class="title">基础组件</div>
        <draggable
          v-if="showBaseComponents"
          class="dragArea list-group flex flex-wrap"
          :list="guiderComponents"
          :sort="false"
          :group="{ name: 'component', pull: 'clone', put: false }"
          @change="log"
          :clone="cloneEnd"
        >
          <!-- :group="{ name: 'component', pull: 'clone', put: false }" -->
          <template v-for="(v, i) in guiderComponents">
            <div class="list-group-item" v-if="v.type === 'custom'" :key="i">
              <span class="hmicon" :class="v.icon"></span>
              <div class="label">{{ v.label }}</div>
            </div>
          </template>
        </draggable>
      </div>
      <!-- 预览容器 -->
      <div class="preview-container">
        <el-scrollbar>
          <div class="preview-wrapper">
            <div class="preview-head">
              <div class="preview-title">{{ title }}</div>
            </div>
            <div class="preview-body">
              <div class="preview-top">
                <img
                  src="https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1586162110285-8b85e3dd-bf48-400e.png"
                  alt
                />
              </div>
              <div class="my-achievement" v-if="tabBarList.showAchievement">
                <img
                  src="https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1586161034621-5133e4bc-2aa1-4b9c.png"
                  alt
                />
                <div class="hm-tabs flex">
                  <div class="tab" v-for="tab in tabBarList.tabList" :key="tab.value">{{tab.name}}</div>
                </div>
              </div>
              <draggable
                class="dragArea preview-list-group"
                :list="previewComponents"
                group="component"
                @change="log"
              >
                <div
                  class="preview-list-group-item"
                  @click="selectPreviewItem(i, v.prop)"
                  :class="{
                    active: activePreviewIndex === i,
                    mb50: i === previewComponents.length - 1
                  }"
                  v-for="(v, i) in previewComponents"
                  :key="i"
                >
                  <component
                    :is="v.component"
                    ref="singleComponent"
                    v-if="v.component !== 'achievement'"
                    :isActive="activePreviewIndex === i"
                    v-bind="v.prop"
                  ></component>
                  <div
                    class="widget"
                    v-if="v.component === 'consumption-range'"
                    @click="deleteCurrentComponent(i)"
                  >
                    <span class="widget-label">{{ v.label }}</span>
                    <span class="widget-icon hmicon icon-shanchu1"></span>
                  </div>
                </div>
              </draggable>

              <div class="preview-height-tag">
                <span class="preview-height-tag-text">iPhone 8手机高度</span>
              </div>
            </div>
          </div>
        </el-scrollbar>
        <div class="tabbar">
          <img
            src="https://imgcdn.hemiao100.com/guide/3779d5ae2e6c87a36d606dbf3c110ff.png"
            alt="tabbar"
          />
        </div>
      </div>
      <!-- 设置项容器 -->
      <div class="options-container">
        <!-- 全局设置 -->
        <div class="page-setting" v-if="showPageSetting">
          <div class="page-header">
            <div class="title">禾店掌首页</div>
            <div class="tips">设置展示内容</div>
          </div>
          <ul class="other-setting p20">
            <li class="flex flex-between item-center">
              <div>
                <span class="mr20">我的业绩</span>
                <span class="sub-title temp">{{
                  tabBarList.showAchievement ? "显示" : "隐藏"
                }}</span>
              </div>
              <div class="item-setting flex flex-end flex-1">
                <el-switch
                  :width="30"
                  v-model="tabBarList.showAchievement"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
            </li>
             <li v-if="tabBarList.showAchievement">
              <div class="mb10">
                选择tabs是否展示
              </div>
              <div>
                 <el-checkbox-group v-model="checkList">
                  <el-checkbox label="shop">门店业绩</el-checkbox>
                  <el-checkbox label="share">分销业绩</el-checkbox>
                  <el-checkbox label="member">会员招募</el-checkbox>
                  <el-checkbox label="memberConversion">会员转化</el-checkbox>
                </el-checkbox-group>
              </div>
            </li>
          </ul>
        </div>
        <!-- 单个组件设置 -->
        <div class="component-setting" v-if="!showPageSetting">
          <!-- 公告 -->
          <div
            class="notice-setting"
            v-if="currentProp && currentProp.name === 'notice'"
          >
            <div class="page-header">
              <div class="mb20">
                <div class="title">公告</div>
                <span class="tips"
                  >请填写内容，如果内容过长，将会在手机上滚动显示</span
                >
              </div>
              <div class="flex">
                <span class="sub-title mr10">公告</span>
                <el-input
                  class="flex-1"
                  size="small"
                  type="textarea"
                  v-model="currentProp.text"
                ></el-input>
              </div>
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between">
                <span class="mr20">文字颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.color"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
          </div>
          <!-- 广告图设置 -->
          <div
            class="banner-setting"
            v-if="currentProp && currentProp.name === 'banner'"
          >
            <div class="p20">
              <div class="title">禾店掌首页</div>
              <div class="tips">
                添加广告图建议尺寸1380x304，可不添加，最多添加三张
              </div>
            </div>
            <draggable :list="currentProp.imgList">
              <ul class="tabbar-setting">
                <li
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.imgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageAd(i)"
                  >
                    <img
                      style="width: 100%"
                      :src="v.src"
                      v-if="v.src"
                      alt="图片广告"
                    />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <!-- <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">链接类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        @change="openGoodsSelect(v, i, 'imgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                      </el-radio-group>
                    </div>-->
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-model="v.hrefAddress"
                        filterable
                        v-if="!v.groupGoods.groupId"
                        @change="selectGroup($event, i)"
                      >
                        <el-option
                          v-for="(item, i) in microShopRouteList"
                          :key="i"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup(i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </draggable>
            <el-button
              type="primary"
              @click="addImageAd"
              plain
              :disabled="currentProp && currentProp.imgList.length >= 3"
              size="small"
              class="w100"
              >添加广告图</el-button
            >
          </div>
          <!-- 我的服务设置 -->
          <div
            class="service-setting"
            v-if="currentProp && currentProp.name === 'myService'"
          >
            <div class="p20">
              <div class="title">我的服务</div>
              <div class="tips">图标风格需保持一致(建议尺寸76x76)</div>
            </div>
            <div class="other-setting">
              <div class="flex flex-between item-center radio-wrapper">
                <div class="flex">
                  <span class="mr20">排列样式</span>
                  <span class="sub-title temp">
                    {{ currentProp.isVertical ? "列表布局" : "水平布局" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.isVertical">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.isVertical }"
                      >
                        <span class="hmicon icon-wangge"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.isVertical }"
                      >
                        <span class="hmicon icon-liebiaobuju"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <draggable class="tabbar-setting" :list="currentProp.serviceList">
                <div
                  class="tabbar-setting-item move"
                  v-for="(item, i) in currentProp.serviceList"
                  :key="i"
                >
                  <div
                    class="delete-tab"
                    v-if="item.custom"
                    @click="deleteCurrentService(i)"
                  >
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="flex">
                    <div class="navbar-icon flex">
                      <div class="un-selected flex">
                        <div
                          class="icon-wrapper"
                          :class="{ 'no-bg': !item.icon }"
                          @click="uploadServiceImg(i)"
                        >
                          <img :src="item.icon" alt="图标" />
                          <div class="change-icon">
                            {{ item.icon ? "更换图标" : "添加图标" }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-1">
                      <div class="flex flex-between">
                        <div class="flex item-center mb10">
                          <span class="mr10">标题</span>
                          <el-input
                            size="small"
                            type="text"
                            style="width: 120px"
                            v-model="item.name"
                            >{{ item.name }}</el-input
                          >
                        </div>
                        <div class="flex flex-between">
                          <!-- <span>{{ item.show ? "显示" : "隐藏" }}</span> -->
                          <el-switch
                            :width="30"
                            v-model="item.show"
                            active-color="#13ce66"
                            :active-value="true"
                            :inactive-value="false"
                          ></el-switch>
                        </div>
                      </div>
                      <div class="link" v-if="item.custom">
                        <span class="mr10">链接</span>
                        <el-select
                          class="flex-1"
                          size="small"
                          clearable
                          placeholder="选择页面"
                          v-model="item.hrefAddress"
                          filterable
                        >
                          <template v-for="(item, i) in microShopRouteList">
                            <el-option
                              :key="i"
                              v-if="item.hrefAddress !== 'groupGoods'"
                              :label="item.hrefName"
                              :value="item.hrefAddress"
                            ></el-option>
                          </template>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
              <div class="add-navigation">
                <el-button
                  type="primary"
                  @click="addServiceList"
                  plain
                  :disabled="
                    currentProp.serviceList &&
                      currentProp.serviceList.length >= 20
                  "
                  size="small"
                  class="w100"
                  >添加</el-button
                >
              </div>
            </div>
          </div>
          <!-- 会员消费设置 -->
          <div
            class="consume-setting"
            v-if="currentProp && currentProp.name === 'consumption-range'"
          >
            <div class="p20">
              <div class="title">会员卡累计消费</div>
              <div class="tips">输入累计消费区间，快捷筛选到会员</div>
            </div>
            <div class="other-setting p20">
              <div class="flex flex-between mb20">
                {{ isOpenBaseText }}
                <span class="mr20">是否显示累计奖励基数</span>

                <el-switch
                  :width="30"
                  v-model="currentProp.isOpenBaseText"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
              <div
                class="flex flex-between item-center mb20"
                v-if="currentProp.isOpenBaseText"
              >
                <span class="mr20">提示文本</span>
                <el-input
                  type="text"
                  maxlength="15"
                  v-model="currentProp.baseText"
                  size="small"
                  placeholder="请输入提示文本"
                ></el-input>
              </div>
              <div class="flex flex-between mb20">
                <span class="mr20">是否显示累计消费奖励</span>
                <el-switch
                  :width="30"
                  v-model="currentProp.isOpen"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
              <div
                class="flex flex-between item-center"
                v-if="currentProp.isOpen"
              >
                <span class="mr20">标题文本</span>
                <el-input
                  type="text"
                  maxlength="15"
                  v-model="currentProp.title"
                  size="small"
                  placeholder="请输入标题"
                ></el-input>
              </div>
            </div>
            <ul class="tabbar-setting">
              <draggable :list="currentProp.consumRange">
                <li
                  class="tabbar-setting-item move"
                  v-for="(v, i) in currentProp.consumRange"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentConsumeLevel(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div>
                    <div class="caption">
                      <template v-if="v.isUpperLimit"
                        >输入累计消费金额
                        <span class="primary">（无上限）</span>
                      </template>
                      <template v-else>输入累计消费金额区间</template>
                    </div>
                    <div class="conditions">
                      大于等于
                      <el-input
                        style="width: 70px; margin: 0 5px"
                        size="mini"
                        type="number"
                        @blur="checkIsValid(v)"
                        v-model="v.min"
                      ></el-input>
                      <template v-if="!v.isUpperLimit">
                        且小于<el-input
                          style="width: 70px; margin: 0 5px"
                          size="mini"
                          type="number"
                          @blur="checkIsValid(v)"
                          v-model="v.max"
                        ></el-input>
                      </template>
                    </div>
                  </div>
                </li>
              </draggable>
            </ul>
            <div class="have-bg-wrapper flex flex-center">
              <el-button
                type="primary"
                @click="addConsumRange(false)"
                plain
                :disabled="
                  currentProp.consumRange && currentProp.consumRange.length >= 5
                "
                size="small"
                >添加</el-button
              >
              <el-button size="small" @click="addConsumRange(true)"
                >添加无上限区间</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 开启全局设置按钮 -->
      <div
        class="page-setting-btn"
        @click="openPageSetting"
        :class="{ active: showPageSetting }"
      >
        <span class="hmicon icon-yemianshezhi"></span>
        <span>页面设置</span>
      </div>
    </div>

    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      v-if="show"
      noCircle
      noSquare
      :width="uploadWidth"
      :height="uploadHeight"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'mallDecoration' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-group-goods
      @saveGroupGoods="saveGroupGoods"
      @close="groupGoodsVisible = false"
      :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
  </div>
</template>

<script>
/* eslint vue/no-unused-components: [0] */
import { guiderComponents, predefine } from "@/utils/tempData";
// import html2canvas from "html2canvas";
import myUpload from "vue-image-crop-upload";
import draggable from "vuedraggable";
import HmRichEditor from "@/components/HmRichEditor";
import tabBar from "@/components/HmMallComponent/tabBar";
import search from "@/components/HmMallComponent/search";
import notice from "@/components/HmMallComponent/notice";
import contactUs from "@/components/HmMallComponent/contactUs";
import dividingLine from "@/components/HmMallComponent/dividingLine";
import richText from "@/components/HmMallComponent/richText";
import titleText from "@/components/HmMallComponent/titleText";
import imageAdSelection from "@/components/HmMallComponent/imageAdSelection";
import imageTextNav from "@/components/HmMallComponent/imageTextNav";
import goodsList from "@/components/HmMallComponent/goodsList";
import consumptionRange from "@/components/hedianzhangComponent/consumptionRange";
import myService from "@/components/hedianzhangComponent/myService";
import banner from "@/components/hedianzhangComponent/banner";
import cube from "@/components/HmMallComponent/cube";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";

export default {
  display: "Clone",
  order: 2,
  components: {
    banner,
    myService,
    consumptionRange,
    tabBar,
    search,
    contactUs,
    dividingLine,
    myUpload,
    notice,
    richText,
    HmRichEditor,
    titleText,
    imageAdSelection,
    imageTextNav,
    goodsList,
    cube,
    HmFilterMicroShopGoods,
    draggable,
    HmFilterGroupGoods
  },
  data() {
    return {
      showBaseComponents: false,
      groupGoodsVisible: false,
      showServiceListTitle: true,
      isRadio: false,
      goodsType: "",
      checkList: ['shop','share','member','memberConversion'],
      tabBarList: {
        showAchievement: false,
         tabList: [
        {
          name: "门店业绩",
          value: "shop",
        },
        {
          name: "分销业绩",
          value: "share",
        },
        {
          name: "会员招募",
          value: "member",
        },
         {
          name: "会员转化",
          value: "memberConversion",
        },
      ],
      },
      pageType: "guiderPage",
      pageModel: "",
      layoutId: "",
      currentImageAd: "",
      uploadType: "",
      uploadWidth: 20,
      uploadHeight: 20,
      currentIndex: "",
      predefine,
      showPageSetting: true,
      dialogVisible: false,
      show: false,
      title: "禾店掌",
      hotWord: "",
      activePreviewIndex: "",
      currentProp: {},
      currentTab: "",
      currentTabIconType: "",
      guiderComponents,
      allComponents: [],
      previewComponents: [
        {
          label: "公告",
          icon: "icon-gonggao",
          type: "base",
          component: "notice",
          prop: {
            iconImage:
              "https://imgcdn.hemiao100.com/guide/ps26905e31dbdbafad-b655-4500-ba2a-d8958a9de3c0.png",
            name: "notice",
            text: "",
            color: "#2b2b2b",
            backgroundColor: "#fff"
          }
        },
        {
          label: "广告位",
          component: "banner",
          prop: {
            name: "banner",
            imgList: []
          }
        },
        {
          label: "我的服务",
          component: "myService",
          prop: {
            name: "myService",
            isVertical: false,
            serviceList: []
          }
        }
      ],
      currentLinkIndex: "",
      currentLinkPropName: ""
    };
  },
  computed: mapGetters(["tempDetails", "microShopRouteList"]),
  watch: {
    tempDetails(val) {
      this.title = val.pageTitle || "个人中心";
      this.previewComponents = val.previewComponents
        ? JSON.parse(val.previewComponents)
        : this.previewComponents;
      if (val.tabBarList) {
        this.tabBarList = JSON.parse(val.tabBarList);
         if (!this.tabBarList.tabList) {
            this.tabBarList.tabList = [
              {
                name: "门店业绩",
                value: "shop",
              },
              {
                name: "分销业绩",
                value: "share",
              },
              {
                name: "会员招募",
                value: "member",
              },
               {
                name: "会员转化",
                value: "memberConversion",
              },
            ]
         }else {
          this.checkList = this.tabBarList.tabList.map(v => v.value)
         }
        
      }
    },
    "currentProp.goodShowType": {
      handler(val) {
        if (val) {
          switch (val) {
            case "big":
              this.type = "大图";
              break;
            case "twoColumn":
              this.type = "一行两个";
              break;
            case "scroll":
              this.type = "横向滑动";
              break;
            default:
              break;
          }
        }
      },
      deep: true
    },
    "currentProp.permutation": {
      handler(val) {
        if (val) {
          this.calcCubeList(val);
        }
      },
      deep: true
    },
    "currentProp.type": {
      handler(val) {
        if (val) {
          this.currentProp.url = "";
        }
      },
      deep: true
    },
    "currentProp.serviceList": {
      handler(val) {
        if (val) {
          this.showServiceListTitle = val.findIndex(v => v.show) > -1;
        }
      },
      deep: true
    },
      checkList: {
        handler(val) {
          // 创建一个映射，用于快速查找现有 tab
          const existingTabs = new Map(this.tabBarList.tabList.map(tab => [tab.value, tab]));

          // 过滤掉不存在于 checkList 中的 tab
          const filteredTabs = this.tabBarList.tabList.filter(tab => val.includes(tab.value));

          // 定义默认 tab 的顺序
          const defaultTabsOrder = ["shop", "share", "member", "memberConversion"];
          // 创建一个映射，用于快速查找 tabMap 中的项
          const tabMap = {
            shop: { name: "门店业绩", value: "shop" },
            share: { name: "分销业绩", value: "share" },
            member: { name: "会员招募", value: "member" },
            memberConversion: { name: "会员转化", value: "memberConversion" }
          };

          // 创建最终的 tab 列表
          const finalTabs = [];

          // 按照默认顺序添加 tab
          defaultTabsOrder.forEach(value => {
            if (val.includes(value)) {
              // 如果 filteredTabs 中已经存在该 tab，则使用已有的
              if (existingTabs.has(value)) {
                finalTabs.push(existingTabs.get(value));
              } else {
                // 否则添加默认的 tab
                finalTabs.push(tabMap[value]);
              }
            }
          });

          // 更新 tabList
          this.tabBarList.tabList = finalTabs;
          if (val.length == 0) {
            this.tabBarList.showAchievement = false
          }
        }
      },
  },
  created() {
    // this.pageType = this.$route.query.pageType;
    // this.pageModel = this.$route.query.pageModel;
    // this.layoutId = this.$route.query.layoutId;
    // this.mode = this.$route.query.mode;
    this.$store.dispatch("queryTempDetails", {
      pageType: this.pageType,
      pageModel: "default"
    });
    this.$store.dispatch("queryMicroShopList", {
      pageType: "guider"
    });
    this.queryIsShowConsumeRankComponent();
    // this.selectPreviewItem(0, this.previewComponents[0].prop);
  },
  methods: {
    async queryIsShowConsumeRankComponent() {
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch(
        "queryIsShowConsumeRankComponent",
        {
          funcCode: "SyncMemberAffixSalesData",
          storeCode
        }
      );
      if (result) {
        this.showBaseComponents = true;
      }
    },
    deleteCurrentComponent(i) {
      this.previewComponents.splice(i, 1);
    },
    checkIsValid(v) {
      if (v.max && v.min && +v.min > +v.max) {
        [v.min, v.max] = [v.max, v.min];
      }
      this.$forceUpdate();
    },
    deleteCurrentConsumeLevel(i) {
      this.currentProp.consumRange.splice(i, 1);
    },
    addConsumRange(isUpperLimit) {
      if (this.checkHaveUpperLimit()) {
        this.$message({
          message: "已添加无上限区间，无法再添加",
          type: "warning"
        });
        return;
      }
      this.currentProp.consumRange.push({
        min: "",
        max: "99999999",
        isUpperLimit
      });
    },
    checkHaveUpperLimit() {
      const result =
        this.currentProp.consumRange.findIndex(v => v.isUpperLimit) > -1;
      return result;
    },
    cloneEnd(prop) {
      return JSON.parse(JSON.stringify(prop));
    },
    log(e) {
      if (e.added) {
        this.activePreviewIndex = e.added.newIndex;
        this.currentProp = {};
        this.currentProp = e.added.element.prop;
      } else if (e.moved) {
        this.activePreviewIndex = e.moved.newIndex;
      }
      this.showPageSetting = false;
    },
    openPageSetting() {
      this.currentProp = {};
      this.activePreviewIndex = "";
      this.showPageSetting = true;
    },
    handleCloseGroup(i) {
      this.currentProp.imgList[i].groupGoods = {};
      this.currentProp.imgList[i].hrefAddress = "";
    },
    saveGroupGoods(row) {
      this.currentProp.imgList[this.currentIndex].groupGoods = row;
      this.groupGoodsVisible = false;
    },
    selectGroup(e, i) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
        this.currentIndex = i;
      }
    },
    deleteCurrentService(i) {
      this.currentProp.serviceList.splice(i, 1);
    },
    addServiceList() {
      this.currentProp.serviceList.push({
        name: "自定义标题",
        icon:
          "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/QQ%E6%88%AA%E5%9B%BE20191025165251.png",
        hrefAddress: "",
        show: true,
        custom: true
      });
    },
    setLink(row) {
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].goodsInfo = row;
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      } else {
        this.currentProp.goodsInfo = row;
        this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    handleClose(v) {
      v.goodsInfo = {};
      v.hrefAddress = "";
      v.pageType = "";
    },
    openGoodsSelect(v, i, propName) {
      if (v.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      v.goodsInfo = {};
      v.hrefAddress = "";
      v.groupGoods = {};
    },
    openGoodsSelectSingle() {
      if (this.currentProp.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }
      this.currentProp.goodsInfo = {};
      this.currentProp.hrefAddress = "";
    },
    handleCloseSingle() {
      this.currentProp.goodsInfo = {};
      this.currentProp.hrefAddress = "";
      this.currentProp.pageType = "";
    },
    addGoods() {
      this.dialogVisible = true;
      this.isRadio = false;
    },
    saveGoods(data) {
      this.dialogVisible = false;
      this.currentProp.goodsList = this.currentProp.goodsList.filter(
        v => !v.isMock
      );
      this.currentProp.goodsList.push(...data);
    },
    deleteCurrentGoods(i) {
      this.currentProp.goodsList.splice(i, 1);
      if (this.currentProp.goodsList && !this.currentProp.goodsList.length) {
        this.currentProp.goodsList.push({
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        });
      }
    },
    addHotWord() {
      this.currentProp.hotWordList.push({
        word: ""
      });
    },
    setPlaceholder() {
      if (this.currentProp.hotWordList && this.currentProp.hotWordList.length) {
        this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
      }
    },
    save() {
      const params = {
        pageType: this.pageType,
        pageTitle: this.title,
        tabBarList: JSON.stringify(this.tabBarList),
        previewComponents: JSON.stringify(this.previewComponents)
      };
      this.$store.dispatch("addTemp", params).then(res => {
        if (res.code === "0") {
          this.$message({
            type: "success",
            message: "操作成功！"
          });
          this.$router.back(-1);
        }
      });
    },
    back() {
      this.$confirm("退出将不会保存当前装修，确认退出?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        this.$router.back();
      });
    },
    deleteCardList(i, prop) {
      this.currentProp[prop].splice(i, 1);
    },
    uploadPlusBg() {
      this.uploadType = "plusBg";
      this.uploadWidth = 1500;
      this.uploadHeight = 720;
      this.show = true;
    },
    uploadServiceImg(i) {
      this.uploadType = "serviceImg";
      this.uploadWidth = 76;
      this.uploadHeight = 76;
      this.show = true;
      this.currentImageAd = i;
    },
    selectPreviewItem(i, prop) {
      this.activePreviewIndex = i;
      this.currentProp = {};
      this.currentProp = prop;
      this.showPageSetting = false;
    },
    cropSuccess() {},
    toggleShow() {
      this.show = !this.show;
    },
    // 添加底部导航栏
    addBannnerImg() {
      this.uploadType = "banner";
      this.uploadWidth = 1380;
      this.uploadHeight = 304;
      this.show = true;
    },
    deleteCurrentImageAd(i) {
      this.currentProp.imgList.splice(i, 1);
    },
    calcCubeList(val) {
      let length = this.currentProp.cubeList
        ? this.currentProp.cubeList.length
        : 0;
      let list = JSON.parse(JSON.stringify(this.currentProp.cubeList));
      if (val < length) {
        list = list.slice(0, val);
      } else if (val > length) {
        for (let i = 0; i < val - length; i++) {
          list.push({
            src:
              "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
            url: ""
          });
        }
      }
      this.currentProp.cubeList = list;
    },
    deleteCurrentBanner(i) {
      this.currentProp.imgList.splice(i, 1);
    },
    changeImageAd(i) {
      this.uploadWidth = 690;
      this.uploadHeight = 152;
      this.show = true;
      this.uploadType = "banner";
      this.currentImageAd = i;
    },
    addImageAd() {
      this.currentProp.imgList.push({
        src:
          "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
        hrefAddress: "",
        pageType: "page",
        text: "",
        goodsInfo: {},
        groupGoods: {}
      });
    },
    cropUploadSuccess(jsonData) {
      const url = jsonData.result;
      switch (this.uploadType) {
        case "plusBg":
          this.tabBarList.plusBg = url;
          break;
        case "banner":
          this.currentProp.imgList[this.currentImageAd].src = url;
          break;
        case "serviceImg":
          this.currentProp.serviceList[this.currentImageAd].icon = url;
          break;
        default:
          break;
      }
    },
    deleteCurrentTab(i) {
      this.tabBarList.splice(i, i);
    },
    cropUploadFail() {}
  }
};
</script>
<style lang="scss">
.user-center-temp-container {
  .el-carousel__indicators {
    display: none;
  }
  .other-setting {
    .radio-wrapper {
      padding: 0 20px;
      margin-bottom: 20px;
      .sub-title {
        margin-bottom: 0 !important;
      }
    }
    .el-radio-group {
      border: 1px solid #ddd;
      border-radius: 5px;
      height: 30px;
      display: flex;
      .el-radio {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-radio__label {
        padding-left: 0;
      }
      .el-radio.is-checked {
        background: #ffeaf3;
      }
      .el-radio {
        margin-right: 0;
        width: 48px;
        height: 30px;
        .hmicon {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.user-center-temp-container {
  .component-list {
    background: #fff;
    padding: 20px;
    width: 219px;
    box-sizing: border-box;
    height: 100vh;
    .title {
      color: #ccc;
      font-size: 16px;
      margin-bottom: 31px;
    }
    .list-group {
      box-sizing: border-box;
    }
    .list-group-item {
      margin-bottom: 28px;
      width: 50%;
      text-align: center;
      padding: 10px;
      box-sizing: border-box;
      .hmicon {
        font-size: 24px;
      }
      .label {
        margin-top: 16px;
        font-size: 14px;
        color: #666;
      }
    }
  }
  .preview-container {
    position: absolute;
    top: 220px;
    left: 219px;
    right: 360px;
    bottom: 0;
    user-select: none;
  }
  .preview-wrapper {
    position: relative;
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
    width: 375px;
    height: 667px;
    margin: 0 auto;
    .preview-head {
      height: 64px;
      width: 375px;
      margin: 0 auto;
      background: url("https://imgcdn.hemiao100.com/hemiaoBase/download.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50%;
      position: relative;
      .preview-title {
        width: 180px;
        margin: 0 auto;
        height: 34px;
        line-height: 26px;
        text-align: center;
        padding-top: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .preview-body {
      position: relative;
      .radius {
        position: absolute;
        top: 207px;
        z-index: 100;
      }
      .preview-list-group {
        height: 553px;
        margin-bottom: 50px;
        .preview-list-group-item {
          position: relative;
          box-sizing: border-box;
          border: 2px solid transparent;
          .widget {
            position: absolute;
            top: 0;
            right: -40px;
            width: 34px;
            cursor: pointer;
            .widget-label {
              display: inline-block;
              background-color: #fff;
              width: 100px;
              height: 24px;
              text-align: center;
              line-height: 24px;
              font-size: 12px;
              pointer-events: none;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            }
            .widget-icon {
              display: none;
            }
            &::before {
              content: "";
              width: 0;
              height: 0;
              border-width: 5px;
              border-style: solid;
              border-color: transparent #fff transparent transparent;
              position: absolute;
              bottom: 7px;
              left: -10px;
            }
          }
          &:hover {
            .widget-icon {
              display: block;
              cursor: pointer;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
              width: 40px;
              height: 28px;
              text-align: center;
              font-size: 16px;
              line-height: 28px;
              background: #fff;
              color: #e71370;
            }
            .widget-label {
              display: none;
              cursor: pointer;
            }
          }
          *:not(.widget-icon) {
            cursor: move !important;
          }
          video {
            height: 210px;
            width: 100%;
            display: block;
          }
          &:last-child {
            margin-bottom: 50px;
          }
          &.active,
          &.active:hover {
            box-sizing: border-box;
            border: 2px solid #ea5798;
            cursor: move;
          }
          &:hover {
            box-sizing: border-box;
            border: 2px dashed #ea5798;
            cursor: move;
          }
        }

        .contact-us-item {
          position: absolute;
          bottom: 23px;
          width: 100%;
          z-index: 11;
          left: 0;
        }
        .list-group-item {
          transition: all 0.2s linear;
          background-color: #fddfeb !important;
          border-radius: 2px;
          color: #e2005d;
          text-align: center;
          .label {
            margin-top: 10px;
          }
        }
      }
      .preview-height-tag {
        position: absolute;
        left: -130px;
        bottom: 0;
        width: 130px;
        display: -ms-flexbox;
        display: flex;
        color: #a2a2a2;
        border-bottom: 1px solid #dedede;
        .preview-height-tag-text {
          padding-top: 4px;
          font-size: 12px;
        }
      }
    }
  }

  .options-container {
    width: 360px;
    position: absolute;
    top: 56px;
    box-sizing: border-box;
    padding-bottom: 100px;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    bottom: 0;
    background: #fff;
    .p20 {
      padding: 20px;
    }
    .have-bg-wrapper {
      padding: 0 20px 20px;
      background: #fafafa;
    }
    .title {
      color: #2b2b2b;
      font-weight: 500;
      font-size: 18px;
      margin-bottom: 18px;
    }
    .tips {
      margin: 18px 0 20px;
      font-size: 12px;
      color: #777;
    }
    .sub-title {
      color: #2b2b2b;
      margin-bottom: 20px;
    }
    .page-header {
      padding: 20px;
      font-size: 14px;
      border-bottom: 1px solid #eee;
    }
    .page-footer {
      font-size: 14px;
      .sub-title {
        background: #fff;
        padding: 20px;
      }
    }
  }

  .border-bottom {
    border-bottom: 1px solid #eee;
  }

  .page-setting {
    .tabbar-setting .tabbar-setting-item .icon-wrapper {
      font-size: 14px;

      img {
        width: 21px;
      }
    }
  }

  .page-setting-btn {
    position: absolute;
    right: 385px;
    top: 100px;
    width: 98px;
    height: 36px;
    text-align: center;
    font-size: 14px;
    background: #fff;
    border-radius: 2px;
    line-height: 36px;
    cursor: pointer;
    user-select: none;
    &.active {
      background: #e2005d;
      color: #fff;
      .hmicon {
        color: #fff;
      }
    }
    .hmicon {
      margin-right: 5px;
    }
  }
  .temp-header {
    height: 56px;
    line-height: 56px;
    background: #e50065;
    color: #fff;
    padding: 0 22px;
    font-size: 16px;
    user-select: none;
    .hmicon {
      color: #fff;
      font-size: 18px;
      margin-right: 10px;
    }
    .btn {
      cursor: pointer;
    }
    .title {
      font-size: 18px;
    }
    .sub-title {
      font-size: 14px;
    }
    .header-list {
      li {
        border-right: 1px solid #fff;
        padding: 0 22px;
      }
      li:last-child {
        padding-right: 0;
        border-right: 0;
      }
    }
  }
  .tabbar-setting {
    background: #fafafa;
    padding: 20px;
    .tabbar-setting-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;
      .delete-tab {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }

      .caption {
        color: #666;
        margin-bottom: 20px;
        font-size: 14px;
      }
      .conditions {
        color: #666;
        font-size: 14px;
      }
      &:hover {
        .delete-tab {
          opacity: 1;
        }
      }
      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          max-width: 36px;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
  .card-list {
    .card-list-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;

      &:hover {
        .card-item-delete {
          opacity: 1;
        }
      }
      .card-item-delete {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
    }
  }
}

.info {
  position: relative;
  .white-bg {
    position: absolute;
    top: 0;
    right: 0;
    background: #fff;
    width: 100px;
    height: 31px;
  }
  .white-bg-type {
    position: absolute;
    top: 9px;
    left: 138px;
    background: #fff;
    width: 80px;
    height: 36px;
  }
}

.other-setting {
  font-size: 14px;
  li {
    margin-bottom: 20px;
    div {
      span:first-child {
        display: inline-block;
        width: 80px;
      }
      .sub-title {
        font-weight: bold;
      }
    }
  }
}
.plus-bg-wrapper {
  position: relative;
  margin: 0 auto;
  width: 300px;
  padding-top: 20px;
  img {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    width: 100%;
    min-height: 150px;
  }
  .tip {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
  }
}

.tabbar {
  position: absolute;
  margin: 0;
  padding: 0;
  left: 50%;
  transform: translateX(-50%);
  bottom: 95px;
  z-index: 31;
  box-sizing: border-box;
  width: 375px;
  height: 70px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.img {
  width: 100%;
}

.member-info {
  background: #fff;
  overflow: hidden;
  height: 150px;
  position: relative;
  .member-card {
    position: relative;
    padding: 0 15px;
    button {
      position: absolute;
      top: 10px;
      right: 20px;
      background: #ffc533;
      border: none;
      border-radius: 30px;
      padding: 5px;
      font-size: 12px;
      outline: 0;
    }
    img {
      border-radius: 5px;
    }
  }
  .info {
    padding: 15px 0;
  }
}

.order-list {
  padding: 15px;
  .img {
    border-radius: 3px;
  }
}

.banner-wrapper {
  .img {
    padding: 0 15px;
    width: calc(100% - 30px);
  }
}

.add-navigation {
  padding: 0 20px;
}

.mb50 {
  margin-bottom: 50px;
}

.preview-top {
  img {
    width: 100%;
    display: block;
  }
}

.notice-wrapper {
  margin-bottom: 10px;
}

.my-achievement {
  img {
    width: 100%;
    display: block;
  }
  .hm-tabs {
		background: #fff;
		padding: 0 20px 20px;
    border-radius: 4px;
    .tab {
      text-align: center;
      height: 26px;
      line-height: 26px;
      background: #EEEEEE;
      color: #999;
      box-sizing: border-box;
      padding: 0 10px;
      white-space: nowrap;
    }
	}
}
</style>
